import type { DashboardData } from "../types";

export async function loadDashboardData(): Promise<DashboardData> {
  const response = await fetch("/data/dashboard-data.json");
  if (!response.ok) throw new Error(`Could not load dashboard data: ${response.status}`);
  return response.json();
}
